// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2061":"24265c56","3575":"ce044c50","4262":"24265c56","4935":"08d55499","4949":"24265c56","6782":"24265c56"}[chunkId] + ".chunk.css";
};